import { Component, inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-cron-expression-edit-modal',
  templateUrl: './cron-expression-edit-modal.component.html',
  styleUrl: './cron-expression-edit-modal.component.scss',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
})
export class CronExpressionEditModalComponent implements OnInit {
  @Input() storeCronExpression: string;
  public value = '0 */12 * * *';

  modal: NgbActiveModal;

  constructor() {
    this.modal = inject(NgbActiveModal);
  }

  ngOnInit() {
    if (this.storeCronExpression && this.storeCronExpression !== 'None') {
      this.value = this.storeCronExpression;
    }
  }

  public confirm(): void {
    this.modal.close(this.value);
  }

  public close(): void {
    this.modal.close(null);
  }

  public disableAutomation(): void {
    this.modal.close('None');
  }
}
